import LoyaltyClaimPointsHome from 'pages/loyalty/loyalty-claim-points/loyalty-claim-points-home';

export default function ClaimPointsHomePage() {
  return <LoyaltyClaimPointsHome />;
}
